var _style, _polygon, _path, _g, _polygon2, _g2, _polygon3, _g3, _path2, _polygon4, _polygon5, _polygon6, _polygon7, _path3, _polygon8, _polygon9, _polygon10, _path4, _polygon11, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLgHdLogos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1442.31 612",
    style: {
      enableBackground: "new 0 0 1442.31 612"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6D6E71;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000149368542780599659800000018445075815587757493_);}\n\t.st3{fill:url(#SVGID_00000152987175184755035280000001451255723388678843_);}\n\t.st4{fill:#616D76;}\n\t.st5{fill:#879AA4;}\n\t.st6{fill:#8E9BA1;}\n\t.st7{fill:url(#SVGID_00000071547541192308818930000005422694313639133615_);}\n\t.st8{fill:url(#SVGID_00000011024935491970270720000006802203204227734204_);}\n\t.st9{fill:#B5BEC4;}\n\t.st10{fill:none;}\n\t.st11{fill:url(#SVGID_00000064324683228888189650000005096165852832425919_);}\n\t.st12{fill:#505C61;}\n\t.st13{fill:#0B2028;}\n\t.st14{fill:#8F9DA5;}\n\t.st15{fill:url(#SVGID_00000080188353483408139840000008030877625032417971_);}\n\t.st16{fill:url(#SVGID_00000122688504016335026900000005298132323022638766_);}\n\t.st17{fill:url(#SVGID_00000115509732384277176990000005059919579677755047_);}\n\t.st18{fill:url(#SVGID_00000165205377123997141980000000290326400414843295_);}\n\t.st19{fill:url(#SVGID_00000049934227278994832090000005357921050615979684_);}\n\t.st20{fill:url(#SVGID_00000075157620964319999880000004747577293673671809_);}\n\t.st21{fill:#FFFFFF;}\n\t.st22{fill:#EE7226;}\n")), /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "423.51,449.09 423.51,455.14 395.3,455.14 395.3,407.91 402.83,407.91 402.83,449.09  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M428.28,422.28h7.38v32.86h-7.38V422.28z M428.21,408.38h7.45v6.6h-7.45V408.38z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464.71,422.28v5.59h-11.33v27.27h-7.38v-27.27h-4.82v-5.59h4.74v-3.96c0-9.88,5.45-12.89,13.05-12.89 c2.63,0,5.45,0.39,7.54,1.23l-1.63,5.29c-1.65-0.62-3.35-0.93-5.12-0.93c-4.67,0-6.46,2.18-6.46,7.3v3.96H464.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M474.66,435.42h14.3c0-6.22-2.19-8.86-6.37-8.86C476.91,426.56,474.9,429.59,474.66,435.42 M466.97,438.52 c0-11.42,5.21-17.01,15.7-17.01c11.5,0,13.91,6.84,13.91,16.09v2.93h-21.98c0.15,6.99,2.86,9.96,9.39,9.96 c4.9,0,8.01-1.55,10.57-2.64l1.55,4.73c-2.49,1.48-8.08,3.34-13.28,3.34C471.09,455.92,466.97,450.17,466.97,438.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M497.39,421.35c3.11-5.29,3.65-9.87,3.65-15.45h6.92c-0.09,8.37-2.03,13.27-5.91,18.4L497.39,421.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M527.98,437.04c4.05,1.4,7.3,3.49,7.3,8.86c0,6.76-5.28,10.01-14.14,10.01c-4.97,0-9.17-0.93-12.43-2.32 l2.26-5.37c2.55,1.25,6.13,2.26,10.24,2.26c3.9,0,6.91-0.78,6.91-3.88c0-1.86-1.38-3.1-4.19-4.12c-2.56-0.86-5.5-1.71-7.76-2.57 c-3.96-1.46-7-3.64-7-8.61c0-7,6.21-9.79,13.75-9.79c5.29,0,9.01,1.02,12.06,2.18l-2.27,5.36c-2.63-1.32-5.98-2.18-9.79-2.18 c-4.66,0-6.67,1.48-6.67,3.65c0,1.78,1.24,2.8,4.03,3.88C521.99,435.1,525.65,436.2,527.98,437.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M597.16,452.74c-4.2,1.93-10.27,3.18-16.87,3.18c-15.23-0.08-21.99-8.55-21.99-24.39 c0-16.55,8.63-24.4,22.69-24.4c6.68,0,12.58,2.1,16.22,6.53l-4.58,4.12c-2.63-2.8-6.3-4.73-11.57-4.73 c-10.19,0-15.08,6.83-15.08,19.19c0,11.42,4.88,17.64,14.68,17.64c3.5,0,6.61-0.48,9.17-1.17v-12.68h-10.88v-5.81h18.2V452.74z"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "423.51,449.09 423.51,455.14 395.3,455.14 395.3,407.91 402.83,407.91 402.83,449.09  "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M627.1,438.29c0-6.37-1.4-11.58-7.69-11.58c-6.98,0-9.17,4.35-9.17,12.43c0,6.44,1.48,11.57,7.62,11.57 C625,450.72,627.1,446.44,627.1,438.29 M602.7,438.6c0-11.42,5.3-17.09,16.71-17.09c11.66,0,15.23,6.6,15.23,17.39 c0,11.42-5.3,17.01-16.79,17.01C606.21,455.92,602.7,449.39,602.7,438.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M663.62,438.29c0-6.37-1.4-11.58-7.7-11.58c-6.98,0-9.15,4.35-9.15,12.43c0,6.44,1.48,11.57,7.61,11.57 C661.52,450.72,663.62,446.44,663.62,438.29 M639.22,438.6c0-11.42,5.28-17.09,16.7-17.09c11.66,0,15.23,6.6,15.23,17.39 c0,11.42-5.27,17.01-16.78,17.01C642.72,455.92,639.22,449.39,639.22,438.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M698.21,448.15v-19.8c-1.86-1.1-3.64-1.48-5.43-1.48c-5.67,0-9.33,3.18-9.33,12.2c0,6.84,2.33,11.5,8.39,11.5 C694.34,450.57,696.28,449.79,698.21,448.15 M675.86,439.45c0-10.49,4.33-17.94,15.75-17.94c2.5,0,4.5,0.38,6.6,1.39v-16.55 l7.38-0.92v41.09l0.63,8.61h-6.38l-0.62-2.16c-2.88,2.11-6.05,2.94-9.71,2.94C680.12,455.92,675.86,449.71,675.86,439.45"
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "432.62,198.97 395.29,198.97 395.29,360.56 509.96,360.56 509.96,329.09 432.62,329.09  "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M592.09,298.97h30.39v28.25c-5.6,2.14-16.52,4.28-26.92,4.28c-33.61,0-44.81-17.08-44.81-51.74 c0-33.06,10.66-52.53,44.26-52.53c18.68,0,29.33,5.87,38.13,17.07l23.21-21.33c-14.15-20.26-38.94-26.39-62.14-26.39 c-52.26,0-79.73,28.53-79.73,82.92c0,54.14,24.8,83.47,79.46,83.47c25.07,0,49.6-6.4,62.93-15.73v-78.4h-64.79V298.97z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: -22.1314,
    cy: 621.3336,
    r: 4.0803,
    gradientTransform: "matrix(31.9334 0 0 -31.9334 916.522 20117.9258)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C00C3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#C00C3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7363,
    style: {
      stopColor: "#BF0C3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8358,
    style: {
      stopColor: "#B90A3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9094,
    style: {
      stopColor: "#B00737"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9701,
    style: {
      stopColor: "#A30330"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A002B"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214.35,155.47c-68.94,0-124.91,55.94-124.91,124.98c0,69.04,55.97,124.98,124.91,124.98 c68.79,0,124.54-55.41,125.07-124.01v-1.95C338.89,210.88,283.14,155.47,214.35,155.47z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047035960311346863700000008488957436123841202_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.2355,
    y1: 171.6157,
    x2: 229.1762,
    y2: 352.7861
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F48996"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#F28693"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    style: {
      stopColor: "#DB5A69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4875,
    style: {
      stopColor: "#CC3750"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6746,
    style: {
      stopColor: "#C31B43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8011,
    style: {
      stopColor: "#C00C3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C00C3F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047035960311346863700000008488957436123841202_)"
    },
    d: "M129.8,195.85 c-41.76,41.77-45.99,105.42-9.32,142.1c36.67,36.66,100.27,32.46,142.05-9.34c41.84-41.86,46.06-105.49,9.41-142.17 c-16.74-16.75-39.1-24.98-62.47-24.98C181.7,161.47,152.52,173.12,129.8,195.85"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111884486490613884910000012599501680222833819_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.022,
    y1: 216.3917,
    x2: 282.2697,
    y2: 367.6394
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CE425C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0902,
    style: {
      stopColor: "#BD3551"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2501,
    style: {
      stopColor: "#A82242"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    style: {
      stopColor: "#9B1438"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6483,
    style: {
      stopColor: "#930933"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#910531"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111884486490613884910000012599501680222833819_)"
    },
    d: "M207.95,336.46l3.09-1.76l-0.01-105.59 l-0.77-1.23l0.77-0.23v-0.16h0.54l9.34-3.2l1.68,2.89c0,0,0.25,0.25,0.23,0.8l-0.09,96.15h22.72l1.82,2.85 c0.17,0.21,0.28,0.45,0.28,1.17v9.67c0,0.54-0.32,0.77-0.7,0.83h-34.76c-0.83,0.03-1.55-0.37-1.74-0.51L207.95,336.46z  M320.71,274.7l-77.31,0.03v12.38l1.92,2.57l0,0c0,0,0.23,0.25,0.66,0.25h58.93h5.68h0.02h0.07c-3.34,48.92-44.6,87.21-93.9,87.21 c-25.12,0-48.74-9.76-66.55-27.41c-17.74-17.67-27.5-41.13-27.5-66.12c0-25,9.25-48.97,26.99-66.61 c17.85-17.61,40.31-26.91,67.2-27.49l5.08-0.08h0.57c0.35-0.04,0.66-0.05,0.66-0.83v-10.14c0-0.74-0.25-1.09-0.25-1.1l-2.28-2.86 l-5.15,0.74l-2.6,0.86c-58.71,0-102.73,49.07-102.73,107.51c0,28.27,11.11,54.89,31.22,74.9c20.09,20.02,46.73,30.15,75.16,30.15 c28.56,0,55.38-10.77,75.46-30.79c20.14-20.01,31.22-46.62,31.22-74.89v-6.1L320.71,274.7z M176.08,225.76 c-9.29,0-16.81,7.49-16.81,16.7c0,9.2,7.52,16.66,16.81,16.66c9.28,0,16.8-7.46,16.8-16.66 C192.88,233.25,185.36,225.76,176.08,225.76z"
  }), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "210.49,334.03 207.95,336.46 245.44,336.46 243,333.96  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "243,326.5 245.44,324.12 220.9,324.12 218,326.5  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "220.9,224.29 207.95,224.29 210.38,226.61 218.13,226.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039092349615198220930000007659578071233552283_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.127,
    y1: 275.2998,
    x2: 220.9014,
    y2: 275.2998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5BEC4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1753,
    style: {
      stopColor: "#99A2A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    style: {
      stopColor: "#646C74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8544,
    style: {
      stopColor: "#424950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#333940"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000039092349615198220930000007659578071233552283_)"
    },
    points: "218.2,326.31 220.9,324.12  220.9,224.29 218.13,226.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092415643804332349970000011772675903145549191_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.9961,
    y1: 330.291,
    x2: 245.438,
    y2: 330.291
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B4BCC2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1351,
    style: {
      stopColor: "#989FA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    style: {
      stopColor: "#585D61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8473,
    style: {
      stopColor: "#373E41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3337"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000092415643804332349970000011772675903145549191_)"
    },
    points: "243,326.5 243,333.96  245.44,336.46 245.44,324.12  "
  }), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "207.95,224.29 207.95,336.46 210.49,334.03 210.38,226.61  "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M160.59,240.54c0,7.63,6.24,13.81,13.91,13.81c7.64,0,13.88-6.18,13.88-13.81c0-7.66-6.24-13.86-13.88-13.86 C166.83,226.69,160.59,232.89,160.59,240.54z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106123695576806261860000005640927568458026922_",
    gradientUnits: "userSpaceOnUse",
    x1: -33.7471,
    y1: 633.4816,
    x2: -30.9028,
    y2: 633.4816,
    gradientTransform: "matrix(8.1027 8.1027 8.1027 -8.1027 -4696.5391 5635.3174)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ABBAC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#202428"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106123695576806261860000005640927568458026922_)"
    },
    d: "M158.18,240.54 c0,8.98,7.31,16.26,16.32,16.26c9.02,0,16.31-7.28,16.31-16.26c0-8.99-7.29-16.3-16.31-16.3 C165.49,224.24,158.18,231.55,158.18,240.54z M188.38,240.54c0,7.63-6.24,13.81-13.88,13.81c-7.67,0-13.91-6.18-13.91-13.81 c0-7.66,6.24-13.86,13.91-13.86C182.14,226.69,188.38,232.89,188.38,240.54z"
  }), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "310.15,284.27 245.36,284.19 242.96,286.72 307.66,286.72 308.95,285.38  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "220.67,186.99 220.67,186.99 220.67,186.99  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "245.36,276.88 317.82,276.77 320.27,274.3 242.96,274.32  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028293649700851933040000006113004290338278566_",
    gradientUnits: "userSpaceOnUse",
    x1: -25.7804,
    y1: 612.2635,
    x2: -22.9365,
    y2: 612.2635,
    gradientTransform: "matrix(53.1048 53.1048 53.1048 -53.1048 -31015.1953 34097.9023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5BEC4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E454D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028293649700851933040000006113004290338278566_)"
    },
    d: "M320.27,280.41v-6.12l-2.45,2.47v3.65 c0,27.64-10.74,53.62-30.27,73.18c-19.51,19.56-45.54,30.33-73.25,30.33c-27.59,0-53.57-10.77-73.09-30.33 c-19.54-19.58-30.3-45.56-30.3-73.18c0-57.09,46.38-103.5,103.38-103.5l3.95-0.05l2.42-2.35l-6.37-0.06 c-58.33,0-105.83,47.53-105.83,105.96c0,28.27,11.02,54.89,31.01,74.9c19.97,20,46.55,31.05,74.81,31.05 c28.36,0,55-11.04,74.96-31.05C309.28,335.3,320.27,308.69,320.27,280.41z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108295686947737508780000004359382678047251638_",
    gradientUnits: "userSpaceOnUse",
    x1: -27.2213,
    y1: 604.799,
    x2: -24.3773,
    y2: 604.799,
    gradientTransform: "matrix(-67.4051 0 0 67.4051 -1524.6844 -40486.1055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5BEC4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#485059"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108295686947737508780000004359382678047251638_)"
    },
    d: "M218.25,184.55l-2.73-0.06h-2.57 c-25.04,0.36-48.56,10.31-66.44,28.07c-18.07,18.11-28.03,42.21-28.03,67.86c0,25.64,9.96,49.71,28.03,67.83 c17.89,17.84,41.5,27.82,66.62,28.12h2.47c49.74-0.63,91.13-39.71,94.49-89.46l0.09-2.65l-1.22,1.12l-1.29,1.34 c-3.32,48.92-44.31,87.21-93.29,87.21c-24.96,0-48.43-9.76-66.12-27.42c-17.63-17.66-27.32-41.13-27.32-66.11 c0-25,9.69-48.5,27.32-66.14c17.73-17.61,41.19-27.34,66.12-27.34l6.3,0.06L218.25,184.55z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M220.67,186.98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135670958324002630870000007661189010753890484_",
    gradientUnits: "userSpaceOnUse",
    x1: -25.8935,
    y1: 603.4126,
    x2: -25.8935,
    y2: 603.4126,
    gradientTransform: "matrix(-67.4051 0 0 67.4051 -1524.6844 -40486.1055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9B8C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B2028"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135670958324002630870000007661189010753890484_)"
    },
    d: "M220.67,186.98"
  }), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "245.36,276.88 242.96,274.32 242.96,286.72 245.36,284.19  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063592225259103957220000004607377230407093671_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.2534,
    y1: 180.7525,
    x2: 220.6724,
    y2: 180.7525
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B4BCC2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1351,
    style: {
      stopColor: "#989FA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    style: {
      stopColor: "#585D61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8473,
    style: {
      stopColor: "#373E41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3337"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000063592225259103957220000004607377230407093671_)"
    },
    points: "218.25,184.57 220.67,186.99  220.67,174.51 218.25,176.86  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000154389135443678689380000003928228594015696030_",
    cx: 89.5789,
    cy: -326.2377,
    r: 229.4647,
    gradientTransform: "matrix(0.6971 0 0 0.6971 109.7092 463.5307)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5295,
    style: {
      stopColor: "#F6F8F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7147,
    style: {
      stopColor: "#E6EBEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    style: {
      stopColor: "#CFD9DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0CCD3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154389135443678689380000003928228594015696030_)"
    },
    d: "M209.32,225.61v109.53h34.83v-9.76H219.3 v-99.77H209.32z M212.97,175.78c-56.96,0.68-103.23,47.35-103.23,104.63c0,27.96,10.89,54.2,30.63,73.96 c19.72,19.77,46.04,30.65,73.88,30.65c28.02,0,54.31-10.88,74.04-30.65c19.76-19.77,30.61-46.01,30.61-73.96v-4.76l-4.13,0.02 h-70.52v9.71h64.72c-0.01,0.23-0.01,1.23-0.03,1.42c-3.36,49.3-44.46,88.46-94.62,88.46c-25.29,0-49.09-9.88-67.06-27.8 c-17.86-17.89-27.72-41.7-27.72-67.05c0-25.37,9.87-49.2,27.72-67.07c17.97-17.86,41.77-27.74,67.06-27.74c1.09,0,3.8,0,5,0.03 v-9.8c-0.99,0-2.62-0.03-3.91-0.05H212.97z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000067197140608652273040000015659723332620391321_",
    cx: 83.9326,
    cy: -327.8127,
    r: 33.5063,
    gradientTransform: "matrix(0.6971 0 0 0.6971 109.7092 463.5307)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5653,
    style: {
      stopColor: "#F6F8F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7879,
    style: {
      stopColor: "#E6EBEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0DADF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067197140608652273040000015659723332620391321_)"
    },
    d: "M159.41,240.54 c0,8.26,6.77,14.94,15.02,14.94c8.25,0,15-6.68,15-14.94c0-8.33-6.75-15-15-15C166.18,225.55,159.41,232.22,159.41,240.54"
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M177.13,228.24c3.44,0,6.58,1.23,9.11,3.19c-2.73-3.56-7.01-5.88-11.8-5.88c-8.27,0-15.03,6.67-15.03,15 c0,4.78,2.32,8.99,5.83,11.72c-1.93-2.51-3.14-5.6-3.14-9.03C162.1,234.94,168.86,228.24,177.13,228.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M219.3,175.84c-1.31-0.02-3.79-0.07-5.05-0.07c-57.57,0-104.5,46.96-104.5,104.65 c0,27.98,10.89,54.2,30.61,73.97c0.63,0.63,1.29,1.23,1.93,1.85c-18.62-19.56-28.88-45.01-28.88-72.16 C113.4,226.52,154.16,178.73,219.3,175.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M219.3,325.38c0,0,7.18,2.08,24.83,2.08v-2.08H219.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M219.3,228.69v-3.09h-9.97v109.54c0,0,3.12-16.66,3.12-106.45H219.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M318.88,275.65l-74.65,0.02v9.71h2.71v-7.01C311.99,278.37,318.88,275.65,318.88,275.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M308.96,285.38c-0.02,0.21-0.02,1.26-0.06,1.45c-3.32,49.27-44.44,88.44-94.6,88.44 c-25.29,0-49.1-9.88-67.06-27.81c-11.7-11.69-19.95-25.94-24.25-41.47c11.22,40.84,48.57,70.42,92.95,70.42 c47.64,0,91.53-37.31,94.26-91.02H308.96z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_38_",
    className: "st22",
    points: "1010.13,155.67 1308.27,155.67 1308.27,453.8 1010.13,453.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1076.23,391.71l-7.75,7.75l-5.11-5.11l7.75-7.75l-20.02-20.02c-3.24-3.24-3.66-3.83-7.75-1.79 c-1.45,0.77-3.07,0.77-4.34-0.43c-2.56-2.56,0.17-5.62,0.51-5.96l24.87-24.87c0.34-0.34,3.41-3.07,5.96-0.51 c1.19,1.28,1.28,2.81,0.43,4.34c-2.13,4-1.53,4.51,1.79,7.75l46.08,46.17c3.24,3.24,3.66,3.92,7.75,1.79 c1.53-0.77,3.07-0.77,4.34,0.43c2.56,2.56-0.17,5.62-0.51,5.96l-24.87,24.87c-0.34,0.34-3.41,3.07-5.96,0.51 c-1.19-1.28-1.19-2.81-0.43-4.34c2.13-4,1.53-4.51-1.79-7.75L1076.23,391.71L1076.23,391.71z M1075.89,453.8h-10.14 c0-0.09,0.09-0.09,0.09-0.17c2.13-4,1.45-4.51-1.79-7.75l-46.17-46.08c-3.24-3.24-3.66-3.92-7.75-1.79c0,0-0.09,0-0.09,0.09v-10.14 l21.21-21.21c0.34-0.34,3.41-3.07,5.96-0.51c1.19,1.28,1.28,2.81,0.43,4.34c-2.13,4.09-1.53,4.51,1.79,7.75l46.08,46.08 c3.24,3.24,3.66,3.92,7.75,1.79c1.53-0.77,3.07-0.77,4.34,0.43c2.56,2.56-0.17,5.62-0.51,5.96L1075.89,453.8L1075.89,453.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1202.56,195.54l23.17-23.17l65.85,65.85l-23.17,23.08c-0.34,0.34-3.41,3.07-5.96,0.51 c-1.19-1.28-1.19-2.81-0.43-4.34c2.13-4,1.53-4.51-1.79-7.75l-46.17-46.08c-3.24-3.24-3.66-3.83-7.75-1.79 c-1.53,0.77-3.07,0.77-4.34-0.43C1199.49,198.94,1202.21,195.88,1202.56,195.54L1202.56,195.54z M1242.42,155.67h13.8l10.99,10.99 c0.43,0.43,2.04,2.21-0.6,4.86c-1.53,1.53-2.81,1.02-4.6,0.17c-9.37-4.86-18.23-4.68-27.17,1.79l-5.11-5.11L1242.42,155.67 L1242.42,155.67z M1308.27,206.52v14.91l-12.69,12.69l-5.11-5.11c6.22-8.01,6.81-18.31,2.13-27.68c-0.68-1.96-1.62-3.92,0-5.45 c2.81-2.81,5.2,0.09,5.54,0.43L1308.27,206.52L1308.27,206.52z M1259.12,197.75c2.73-4.68,0.94-9.8-1.62-13.88 c-1.02-1.96-1.96-3.83-0.09-5.71c2.73-2.73,5.45,0.85,6.13,1.62l19,19c0.68,0.68,4.34,3.41,1.62,6.13 c-1.87,1.87-3.75,0.94-5.71-0.09c-4.17-2.56-9.2-4.34-13.88-1.62L1259.12,197.75L1259.12,197.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    className: "st21",
    d: "M1177.43,442.9l-10.9,10.9h-5.79c0.17-0.34,0.34-0.68,0.51-1.11 c0.68-1.19-0.77-2.47-1.53-3.24l-25.9-25.9c-0.77-0.77-1.96-2.21-3.24-1.53c-1.36,0.68-2.39,1.45-3.66,0.17 c-1.28-1.28-0.17-2.64,0.77-3.66l12.69-12.69L1177.43,442.9L1177.43,442.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1260.31,286l12.1-12.1l31.43,31.43c1.79,1.87,2.04,2.21,4.34,1.02v5.71l-11.84,11.84 c-0.17,0.17-1.96,1.7-3.32,0.26c-0.68-0.68-0.68-1.62-0.26-2.39c1.19-2.3,0.85-2.56-1.02-4.34L1260.31,286L1260.31,286z  M1293.36,276.03c0.17,0.17,1.28,1.62-0.17,3.07c-1.36,1.36-2.9,0.34-4.17-0.6c-3.07-2.13-7.07-4.77-11.41-4l-2.9-2.9l7.16-7.16 L1293.36,276.03L1293.36,276.03z M1250.94,295.37l7.16-7.16l2.9,2.9c-0.77,4.43,1.79,8.35,4,11.41c0.94,1.28,1.96,2.81,0.6,4.17 c-1.45,1.45-2.9,0.43-3.07,0.17L1250.94,295.37L1250.94,295.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1099.91,305.76c-2.64,5.62-0.34,8.6,1.87,10.82l45.57,45.57c2.21,2.21,5.2,4.51,10.82,1.87l5.11,5.11 c-20.27,16.95-44.04,10.56-61.59-6.9c-17.55-17.55-23.85-41.23-6.9-61.59L1099.91,305.76L1099.91,305.76z M1162.18,360.02 c2.64-5.62,0.34-8.6-1.87-10.82l-45.57-45.57c-2.21-2.21-5.2-4.51-10.82-1.87l-5.11-5.11c20.27-16.95,44.04-10.56,61.59,6.9 c17.55,17.55,23.85,41.23,6.9,61.59L1162.18,360.02L1162.18,360.02z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "st21",
    d: "M1259.2,265.13c-1.28-1.19-2.81-1.28-4.34-0.43c-4,2.13-4.51,1.53-7.75-1.79l-46.08-46.08 c-3.24-3.24-3.92-3.66-1.79-7.75c0.77-1.45,0.77-3.07-0.43-4.34c-2.56-2.56-5.62,0.17-5.96,0.51l-23.17,23.17l18.91,35.09 l-0.17,0.17l-36.37-17.63l-22.32,22.32c-1.02,1.02-3.66,3.66-0.94,6.39c2.13,2.13,4.68-0.09,5.79-1.02 c1.62-1.36,2.98-0.68,5.11-0.17c1.87,0.43,3.58,1.36,5.37,2.21l72.83,36.12l2.56-2.56l-35.69-65.85l40.89,40.89 c3.24,3.24,3.83,3.75,1.79,7.75c-0.77,1.53-0.77,3.07,0.43,4.34c2.56,2.56,5.62-0.17,5.96-0.51l24.87-24.87 C1259.03,270.75,1261.76,267.68,1259.2,265.13L1259.2,265.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    className: "st21",
    d: "M1190.37,311.55l-15.16-15.16l-19.42-9.63l-0.17,0.17l29.64,29.64 c9.63,12.44,0.51,14.57,4.34,18.4c2.73,2.73,6.13-1.02,7.07-2.04l10.05-9.97c0.94-0.94,4.77-4.34,1.96-7.07 C1204.94,312.06,1202.81,321.09,1190.37,311.55L1190.37,311.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    className: "st21",
    d: "M1142.59,403.72c8.35-8.52,21.21-9.71,34.58,2.47c12.18,11.07,10.73,26.32,2.47,34.5l-2.9-2.9 c2.64-3.41-0.09-6.39-1.96-8.26l-21.04-21.12c-1.87-1.87-4.86-4.51-8.26-1.96L1142.59,403.72L1142.59,403.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1161.07,385.23l13.03-13.03l37.05,37.05l-13.12,13.03c-0.17,0.17-1.96,1.7-3.41,0.26 c-0.68-0.68-0.68-1.62-0.26-2.39c1.19-2.3,0.85-2.56-1.02-4.34l-25.9-25.9c-1.87-1.79-2.04-2.21-4.34-1.02 c-0.85,0.43-1.7,0.43-2.47-0.26C1159.28,387.19,1160.9,385.4,1161.07,385.23L1161.07,385.23z M1176.32,369.99l11.07-10.99 l10.05,10.05c0.26,0.26,1.11,1.28-0.34,2.73c-0.85,0.85-1.62,0.6-2.56,0.09c-5.28-2.73-10.22-2.64-15.33,1.02L1176.32,369.99 L1176.32,369.99z M1210.48,404.06c3.49-4.51,3.83-10.31,1.28-15.59c-0.43-1.11-0.94-2.13,0-3.07c1.62-1.62,2.9,0.09,3.15,0.26 l9.88,9.88l-11.41,11.41L1210.48,404.06L1210.48,404.06z M1192.84,386.51c1.53-2.64,0.51-5.45-0.85-7.84 c-0.6-1.11-1.11-2.21-0.09-3.24c1.53-1.53,3.07,0.51,3.49,0.94l10.73,10.73c0.43,0.43,2.39,1.96,0.85,3.49 c-1.02,1.02-2.13,0.51-3.24-0.09c-2.3-1.45-5.2-2.39-7.84-0.85L1192.84,386.51L1192.84,386.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1206.47,339.83c4.68-4.68,8.01-6.98,11.67-8.01c5.88-1.53,10.56,0.34,14.74,4.51 c4.17,4.17,5.96,8.86,4.51,14.74c-1.02,3.66-3.24,6.9-8.01,11.67l-2.9-2.9c2.39-3.49,0.51-5.62-1.96-8.09l-7.5-7.5 c-2.21-2.21-4.68-3.83-7.75-1.62L1206.47,339.83L1206.47,339.83z M1197.7,359.76c-1.79-1.87-2.04-2.21-4.34-1.02 c-0.85,0.43-1.7,0.43-2.39-0.26c-1.45-1.45,0.09-3.15,0.34-3.32l13.03-13.03l31.52,31.52c1.79,1.79,2.04,2.21,4.34,1.02 c0.85-0.43,1.7-0.43,2.47,0.26c1.45,1.45-0.09,3.15-0.26,3.32l-14.23,13.88c-0.17,0.17-1.53,1.36-2.98-0.09 c-0.68-0.68-0.85-1.45-0.34-2.3c1.19-2.3,0.6-2.21-1.28-4.09L1197.7,359.76L1197.7,359.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1237.82,312.74c-1.45,3.15-0.17,4.86,1.02,6.05l25.64,25.64c1.28,1.28,2.9,2.56,6.05,1.02l2.9,2.9 c-11.41,9.54-24.79,5.96-34.67-3.83c-9.88-9.88-13.37-23.17-3.83-34.67L1237.82,312.74L1237.82,312.74z M1272.83,343.24 c1.45-3.15,0.17-4.86-1.02-6.05l-25.64-25.64c-1.28-1.28-2.9-2.56-6.05-1.02l-2.9-2.9c11.41-9.54,24.79-5.96,34.67,3.83 c9.88,9.88,13.46,23.17,3.83,34.67L1272.83,343.24L1272.83,343.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1045.82,268.54l11.41-11.41l29.56,29.56c1.7,1.7,1.96,2.04,4.09,0.94c0.77-0.43,1.62-0.43,2.3,0.26 c1.36,1.36-0.09,2.98-0.26,3.15l-13.2,13.2c-0.17,0.17-1.79,1.62-3.15,0.26c-0.68-0.68-0.68-1.45-0.26-2.3 c1.11-2.13,0.77-2.39-0.94-4.09L1045.82,268.54L1045.82,268.54z M1076.91,259.25c0.17,0.17,1.19,1.45-0.17,2.9 c-1.28,1.28-2.73,0.34-3.92-0.6c-2.9-2.04-6.64-4.43-10.73-3.75l-2.73-2.73l6.73-6.73L1076.91,259.25L1076.91,259.25z  M1037.05,277.31l6.73-6.73l2.73,2.73c-0.68,4.17,1.7,7.84,3.75,10.73c0.85,1.19,1.87,2.64,0.6,3.92c-1.36,1.36-2.73,0.34-2.9,0.17 L1037.05,277.31L1037.05,277.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1110.99,262.57c1.7,1.7,1.96,2.04,4.09,0.94c0.77-0.43,1.62-0.43,2.3,0.26c1.36,1.36-0.09,2.98-0.26,3.15 l-13.2,13.12c-0.17,0.17-1.79,1.62-3.15,0.26c-0.68-0.68-0.68-1.53-0.26-2.3c1.11-2.13,0.77-2.39-0.94-4.09l-24.36-24.36 c-1.7-1.7-1.96-2.04-4.09-0.94c-0.77,0.43-1.62,0.43-2.3-0.26c-1.36-1.36,0.09-2.98,0.26-3.15l13.2-13.2 c0.17-0.17,1.79-1.62,3.15-0.26c0.68,0.68,0.68,1.53,0.26,2.3c-1.11,2.13-0.77,2.39,0.94,4.09L1110.99,262.57L1110.99,262.57z  M1106.13,245.28l-4.09,4.09l-2.73-2.73l4.09-4.09l-10.56-10.56c-1.7-1.7-1.96-2.04-4.09-0.94c-0.77,0.43-1.62,0.43-2.3-0.26 c-1.36-1.36,0.09-2.98,0.26-3.15l13.2-13.12c0.17-0.17,1.79-1.62,3.15-0.26c0.68,0.68,0.68,1.45,0.26,2.3 c-1.11,2.13-0.77,2.39,0.94,4.09l24.36,24.36c1.7,1.7,1.96,2.04,4.09,0.94c0.77-0.43,1.62-0.43,2.3,0.26 c1.36,1.36-0.09,2.98-0.26,3.15l-13.2,13.2c-0.17,0.17-1.79,1.62-3.15,0.26c-0.68-0.68-0.68-1.45-0.26-2.3 c1.11-2.13,0.77-2.39-0.94-4.09L1106.13,245.28L1106.13,245.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1104.26,210.1l12.27-12.27l34.75,34.75l-12.27,12.27c-0.17,0.17-1.79,1.62-3.15,0.26 c-0.68-0.68-0.68-1.45-0.26-2.3c1.11-2.13,0.77-2.39-0.94-4.09l-24.28-24.28c-1.7-1.7-1.96-2.04-4.09-0.94 c-0.77,0.43-1.62,0.43-2.3-0.26C1102.64,211.98,1104.09,210.27,1104.26,210.1L1104.26,210.1z M1118.65,195.79l10.39-10.39 l9.46,9.46c0.26,0.26,1.11,1.19-0.34,2.56c-0.77,0.77-1.45,0.6-2.39,0.09c-4.94-2.56-9.63-2.47-14.4,0.94L1118.65,195.79 L1118.65,195.79z M1150.77,227.82c3.32-4.26,3.66-9.71,1.19-14.65c-0.34-1.02-0.85-2.04,0-2.9c1.45-1.45,2.73,0.09,2.9,0.26 l9.28,9.28l-10.73,10.73L1150.77,227.82L1150.77,227.82z M1134.16,211.29c1.45-2.47,0.51-5.2-0.85-7.33 c-0.6-1.02-1.02-2.04-0.09-2.98c1.45-1.45,2.9,0.43,3.24,0.85l10.05,10.05c0.34,0.34,2.3,1.79,0.85,3.24 c-0.94,0.94-2.04,0.51-3.07-0.09c-2.21-1.36-4.86-2.3-7.33-0.85L1134.16,211.29L1134.16,211.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1288.5,441.71c0-4.77,3.66-8.35,8.09-8.35c4.34,0,8.01,3.58,8.01,8.35c0,4.86-3.75,8.43-8.01,8.43 C1292.25,450.06,1288.5,446.56,1288.5,441.71L1288.5,441.71z M1296.6,448.69c3.58,0,6.47-2.98,6.47-6.98s-2.81-6.98-6.47-6.98 c-3.66,0-6.47,2.98-6.47,6.98S1292.93,448.69,1296.6,448.69L1296.6,448.69z M1294.89,446.56h-1.36v-9.63h3.49 c2.13,0,3.24,0.85,3.24,2.73c0,1.7-1.02,2.47-2.39,2.64l2.64,4.26h-1.53l-2.39-4.17h-1.62v4.17H1294.89z M1296.6,441.11 c1.19,0,2.21-0.09,2.21-1.53c0-1.19-1.02-1.45-2.04-1.45h-1.87v2.98H1296.6L1296.6,441.11z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgHdLogos);
export default __webpack_public_path__ + "static/media/lg-hd-logos.63ecb937b042b56f05ac0bf4f7d5a272.svg";
export { ForwardRef as ReactComponent };